import { memo } from 'react'
import { Link, SwipeableDrawer } from '@mui/material'

import { useDomainInfo, ROUTES } from '@/utils'
import { BookSeatsStackedIconBlack, CrossIconLight, FanaticsLogo } from '@/assets'
import { Box } from '@/components/Layout'

import { navigationDrawerStyles as drawerStyles } from './NavigationDrawer.styles'
import { navigationDrawerClasses } from './NavigationDrawer.data'
import { NavigationList } from './NavigationList'
import { NavigationDrawerFooter } from './NavigationDrawerFooter'

interface NavigationDrawerProps {
  isDrawerOpen: boolean
  toggleDrawer: (currentState: boolean) => void
}

const NavigationDrawer = ({ isDrawerOpen, toggleDrawer }: NavigationDrawerProps) => {
  const { isFanaticsDomain } = useDomainInfo()

  return (
    <SwipeableDrawer
      anchor={'right'}
      open={isDrawerOpen}
      slotProps={{
        paper: {
          sx: drawerStyles.container,
        },
      }}
      onOpen={() => toggleDrawer(true)}
      onClose={() => toggleDrawer(false)}>
      <>
        <Box sx={drawerStyles.headerContainer}>
          <Link href={ROUTES.HOME} onClick={() => toggleDrawer(false)}>
            {isFanaticsDomain ? (
              <FanaticsLogo
                className={`${navigationDrawerClasses.logo} ${navigationDrawerClasses.logoFanatics}`}
              />
            ) : (
              <BookSeatsStackedIconBlack className={navigationDrawerClasses.logo} />
            )}
          </Link>
          <Box onClick={() => toggleDrawer(false)}>
            <CrossIconLight className={navigationDrawerClasses.crossIcon} />
          </Box>
        </Box>

        <NavigationList isDrawerOpen={isDrawerOpen} closeDrawer={toggleDrawer} />
        <NavigationDrawerFooter />
      </>
    </SwipeableDrawer>
  )
}

export default memo(NavigationDrawer)
